function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0v14.643h15V0H0zm.77.77h13.46v9.086L11.81 7.43a.4.4 0 00-.553.012l-2.422 2.595-3.756-3.763a.39.39 0 00-.529-.012L.769 9.718V.77zm7.884 1.542A1.93 1.93 0 006.73 4.239a1.93 1.93 0 001.923 1.926 1.93 1.93 0 001.923-1.926 1.93 1.93 0 00-1.923-1.927zm0 .77A1.15 1.15 0 019.808 4.24a1.15 1.15 0 01-1.154 1.156A1.15 1.15 0 017.5 4.239a1.15 1.15 0 011.154-1.156zM4.796 7.08l3.78 3.787a.4.4 0 00.552-.012L11.55 8.26l2.68 2.686v2.926H.77v-3.107L4.796 7.08z",
  fill: "#000",
  fillOpacity: 0.5
});

function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgImage;